<script>
    // import Translations from "./insert-me-to-translate.vue";

    export default {
        props: ['postUrl'],
        methods: {
            copyOnClipboard: function(){
                var notificationText = gettext("Link copied");
                const el = document.createElement('textarea');
                el.value = this.postUrl;
                document.body.appendChild(el);
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);

                var notificationTag = $("div.copy-notification");
                notificationTag = $("<div/>", {
                    "class": "copy-notification",
                    text: notificationText
                });
                $("body").append(notificationTag);
                notificationTag.fadeIn("slow", function() {
                    setTimeout(function() {
                        notificationTag.fadeOut("slow", function() {
                            notificationTag.remove();
                        });
                    }, 1000);
                });
            }

        }
    };
</script>
